<style lang="scss" scoped>
    .largerCard {
        width: 1200px;
        margin: 40px auto 0;
        box-shadow: 0 0 10px #ddd;
    }

    .shoppingCart {
        .header, .item {
            height: 70px;
            line-height: 70px;
            font-size: 18px;

            .select {
                width: 50px;
                padding-left: 30px;

                i {
                    font-size: 20px;
                    color: #666;
                    font-weight: 500;
                    cursor: pointer;
                    margin-right: 5px;

                    &.active {
                        color: #90ca6f;
                    }
                }
            }

            .img {
                width: 130px;
            }

            .prodName {
                width: 450px;
            }

            .price {
                width: 110px;
                text-align: center;
            }

            .number {
                width: 170px;
                text-align: center;
            }

            .Subtotal {
                width: 150px;
                text-align: center;
            }

            .operation {
                flex: 1;
                text-align: center;
                color: #999;
            }
        }

        .item {
            border-top: 1px solid #eee;
            height: 100px;
            line-height: 100px;
            padding: 15px 0;
        }

        .footer {
            border-top: 1px solid #eee;
            text-align: right;
            padding: 25px 40px;
            font-size: 18px;

            span {
                margin-left: 50px;
                font-size: 24px;
                color: #e23844;
                font-weight: 600;
            }
        }
    }

    ::v-deep .el-input-number__decrease:hover,
    ::v-deep .el-input-number__increase:hover {
        color: #90ca6f;
    }

    ::v-deep .el-input-number__decrease:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled),
    ::v-deep .el-input-number__increase:hover:not(.is-disabled) ~ .el-input .el-input__inner:not(.is-disabled) {
        border-color: #90ca6f;
    }

    ::v-deep .el-input__inner {
        border-radius: 0;
    }

    :v-deep .el-input__inner:focus {
        border-color: #90ca6f;
        outline: 0
    }

    ::v-deep .el-input.is-active .el-input__inner,
    ::v-deep .el-input__inner:focus {
        border-color: #90ca6f;
        outline: 0
    }

    .ReceivingWay, .remarks {
        padding-bottom: 20px;

        .header {
            line-height: 70px;
            font-size: 18px;
            padding: 0 30px;
        }

        .item {
            padding: 10px 30px;
            font-size: 16px;
            cursor: pointer;

            i {
                display: inline-block;
                width: 50px;
                line-height: 48px;
                font-size: 24px;
                color: #ccc;
                font-weight: 500;

                &.active {
                    color: #90ca6f;
                }
            }

            div {
                flex: 1;
                line-height: 24px;
                color: #888;

                span {
                    color: #333;
                }
            }
        }

        textarea {
            display: block;
            height: 60px;
            padding: 10px;
            color: #666;
            width: 1120px;
            font-size: 14px;
            border: 1px solid #eee;
            margin: 0 auto;
            outline: none;
        }

        .sjr {
            padding-bottom: 20px;
            max-height: 350px;
            overflow-y: auto;
            width: 1180px;

            .item {
                font-size: 14px;
                float: left;
                height: 60px;
                overflow: hidden;
                line-height: 20px;
                width: 450px;
                margin: 10px 0 0 80px;
                border: 2px dashed #eee;
                padding: 15px;
                color: #666;

                span {
                    font-weight: 600;
                    margin-right: 20px;
                }

                a {
                    color: #e23844;
                }

                &.active {
                    border: 2px solid #90ca6f;
                    background: #90ca6f;
                    color: #fff;
                }
            }

            .add {
                line-height: 60px;
                text-align: center;
                font-size: 16px;
                color: #888;
            }
        }

    }

    .remarks {
        margin-bottom: 40px;
    }

    .ReceivingTips {
        text-align: right;
        font-size: 16px;
        color: #e23844;
    }

    .shoppingCartBtns {
        text-align: right;
        padding-bottom: 40px;

        button {
            outline: none;
            border: none;
            width: 190px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            font-size: 20px;
            color: white;
            cursor: pointer;

            &.addCar {
                background: #F9B451;

                &:hover {
                    background: #F8A221;
                }
            }

            &.buy {
                background: #E23844;
                margin-left: 40px;

                &:hover {
                    background: #DB202E;
                }
            }

            &.beforeSaleBtn {
                background: #999;
                color: white;
            }
        }
    }

    ::v-deep .el-dialog {
        width: 98%;
        max-width: 1200px;
    }

    ::v-deep .el-dialog__body {
        padding: 0 20px;
    }

    ::v-deep .receiptor-header {
        margin-top: 10px;
    }
    .clearcart {
        float: right;
        display: block;
        text-align: right;
        margin-bottom: 10px;
        font-size:14px;
        color: #999;
    }
    .clearb {
        clear: both;
    }
    .card_empty {
        text-align: center;
        height: 80px;
        line-height: 80px;
        background: #fff;
    }
    .shopcart_consignor {
        .unit {
            margin-bottom: 15px;
            width: 40%;
            margin-left: 80px;
            min-width: 200px;
        }
    }
    .tickets {
        width: 500px;
        margin-left: 80px;
        .cashbox {
            width: 100%;
            padding: 15px 0;
            div {
                float: right;
            }
            .cash {
                color: #f21c0d;
                font-size: 20px;
                font-weight: bold;
            }
            input {
                margin-left: 20px;
                width: 120px;
                height: 40px;
                line-height: 40px;
                text-indent: 6px;
                border-radius: 4px;
                border: 1px solid #e5e5e5;
            }
        }
        .couponsbox {
            padding: 15px 0;
            width: 100%;
            font-size: 16px;
            display: inline-block;
            .couponsinside {
                float: right;
                cursor: pointer;
                text-align: right;
                width: 200px;
                .red {
                    color: #f21c0d;
                    font-weight: bold;
                    font-size: 18px;
                }
            }
        }
    }
    .paymentAmount {
        line-height: 2;
        padding-right: 20px;
        color: #e23844;
        text-align: right;
        font-size: 24px;
        font-weight: 600;
        margin-bottom: 20px;
    }
    .money_type {
        margin: 0 0 0 40px;
        padding-top: 20px;
    }
</style>

<template>
    <div>
        <div class="largerCard shoppingCart">
            <div class="money_type" v-if="!isDirectOrder">
                <template v-for="item in priceTypes">
                    <el-button :key="item.type" type="success" :plain="item.type !== priceType" size="lg" @click="changePriceType(item.type)">{{ item.value }}商品</el-button>
                </template>
            </div>
            <div class="header rowflex">
                <div class="select"><i :class="{'iconfont':true, 'icon-xuanze':true, active: selectedAll}"
                                       @click="selectAllHandle" v-if="!isDirectOrder"></i></div>
                <div class="img">图片</div>
                <div class="prodName">产品名称</div>
                <div class="price">单价</div>
                <div class="number">数量</div>
                <div class="Subtotal">小计</div>
                <div class="operation" v-if="!isDirectOrder">操作</div>
            </div>
            <div class="item rowflex" v-for="(item, index) in items" :key="index">
                <div class="select"><i
                    :class="{'iconfont':true, 'icon-xuanze':true,active: selections.filter(x => x.commodityId === item.commodityId).length>0}"
                    @click="changeSelectState(item)" v-if="!isDirectOrder"></i></div>
                <div class="img"><img :src="item.commodity.imageUrl" width="100" height="100" alt="">
                </div>
                <div class="prodName">{{item.commodity.name}}</div>
                <div class="price">{{ getPriceType(item.commodity.priceType).symbol }}{{item.commodity.price}}</div>
                <div class="number">
                    <el-input-number :min="1" v-model="item.quantity" @change="changeNumber(item)" :max="100000"
                                     size="small"></el-input-number>
                </div>
                <div class="Subtotal">{{ getPriceType(item.commodity.priceType).symbol }}{{toFixed(item.commodity.price * item.quantity)}}</div>
                <div class="operation" @click="deleteItem(item)" v-if="!isDirectOrder">删除</div>
            </div>
            <div class="card_empty" v-if="!items || items.length <= 0">暂无数据...</div>
            <div class="footer">
                <a href="javascript:void(0)" class="clearcart" v-if="items && items.length > 0 && !isDirectOrder" @click="clearCart()">清空购物车</a>
                <div class="clearb"></div>
                估重：{{orderWeight}}kg
                <span id="total">商品合计：{{ getPriceType(priceType).symbol }}{{commodityAmount}}</span>
            </div>
        </div>

        <div class="largerCard ReceivingWay" v-if="!priceType">
            <div class="header">使用账户余额&优惠券</div>
            <div class="tickets">
                <div class="cashbox" v-if="myInfos.cash && myInfos.cash > 0">
                    账户可用余额：<span class="cash">$ {{myInfos.cash}}</span>澳币
                    <div>
                        本次使用<input class="cashcount" maxlength="5" v-model="cashAmount" @blur="useCashAmount" placeholder="" /> 澳币
                    </div>
                </div>
                <div class="couponsbox">
                    优惠券
                    <span class="couponsinside"><span class="coupons" @click="isShowCoupons=true">
                        <span v-if="!couponsItem.amount || couponsItem.amount <= 0">查看可用优惠券</span>
                        <span class="red" v-else>${{couponsItem.amount}}</span>
                    </span> <i class="el-icon-arrow-right"></i></span>
                </div>
            </div>
        </div>

        <div class="largerCard ReceivingWay">
            <template v-if="!createOrderModel.tenantId">
            <div class="header">收件人<span style="color: #999; margin-left: 10px; font-size: 13px;">(如选择自提可不填写)</span></div>
            <div class="sjr clearfix">
                <div class="item active" v-if="createOrderModel.addressee">
                    <span>{{createOrderModel.addressee.name}}，{{createOrderModel.addressee.tel}}</span><br/>
                    {{createOrderModel.addressee.detail}}
                </div>
                <div class="item add" @click="receiptorDialogVisible=true">
                    + 选择 / 新增 / 修改收件人
                </div>
            </div>
            </template>
            <div class="header">寄件人</div>
            <div class="shopcart_consignor">
                <div class="unit">
                    <el-input v-model="createOrderModel.consignor.name" placeholder="请输入寄件人姓名"></el-input>
                </div>
                <div class="unit">
                    <el-input v-model="createOrderModel.consignor.tel" placeholder="请输入寄件人电话"></el-input>
                </div>
            </div>

            <div class="header">取货方式</div>
            <div class="item rowflex" @click="choiseReceivingWay(null)">
                <i :class="{'iconfont':true,'icon-xuanze':true, 'active':createOrderModel.tenantId === null}"></i>
                <div v-if="!priceType">
                    <span>澳洲直邮</span><br/>运费：{{ getPriceType(priceType).symbol }}{{freight}}
                </div>
                <div v-else>
                    <span>默认</span><br/>运费：{{ getPriceType(priceType).symbol }}{{freight}}
                </div>
            </div>
            <!--<div class="sjr clearfix">-->
            <!--<div :class="{'item':true, 'active':recipient===item}" v-for="item in 3" @click='chooseRecipient(item)'>
                <span>王老三，15928134484</span>　　　　<a @click='edit(item,$event)'>编辑</a><br/>
                中国四川省成都市新都区大丰镇赵家寺路276号保利春天花语1单元10栋301
            </div>
            <div class="item add">
                + 添加收件人
            </div>-->
            <!--<div class="item active" v-if="createOrderModel.addressee">
                <span>{{createOrderModel.addressee.name}}，{{createOrderModel.addressee.tel}}</span>
                &lt;!&ndash;　　　　<a @click='edit(item,$event)'>编辑</a>&ndash;&gt;<br/>
                {{createOrderModel.addressee.detail}}
            </div>
            <div class="item add" @click="receiptorDialogVisible=true">
                + 选择 / 新增 / 修改收件人
            </div>
        </div>-->
            <template v-for="item in shops">
                <div class="item rowflex" v-if="item.showOnHome && !priceType" :key="item.id" @click="choiseReceivingWay(item)">
                    <i :class="{'iconfont':true,'icon-xuanze':true, 'active':createOrderModel.tenantId === item.id}"></i>
                    <div>
                        <span>自提（{{item.name}}）</span><br/>{{item.address.detail}} (电话：{{item.tel}})
                    </div>
                </div>
            </template>
            <div v-if="orderAmountJson && orderAmountJson.takePhotoAmount && !priceType">
                <div class="header">其他费用</div>
                <div class="item rowflex" @click="choiseServiceFee()">
                    <i :class="{'iconfont':true,'icon-xuanze':true, 'active': needTakePhoto}"></i>
                    <div>
                        <span>标记拍照服务费：${{orderAmountJson && orderAmountJson.takePhotoAmount}}澳币</span><br/>(${{orderAmountJson && orderAmountJson.takePhotoPrice}}/箱 * {{orderAmountJson && orderAmountJson.parcelCount}}箱)
                    </div>
                </div>
            </div>
        </div>

        <div class="largerCard remarks">
            <div class="header">给卖家留言</div>
            <textarea name="" id="" cols="30" v-model="createOrderModel.remark" rows="10"></textarea>

        </div>
        <div class="container">
            <div class="paymentAmount">
                应付金额：{{ getPriceType(priceType).symbol }}{{paymentAmount}} <span style="font-size: 16px; color: #999; margin-left: 1rem;" v-if="!priceType">(人民币约：{{paymentAmountRMB}}元)</span>
            </div>
        </div>
        <div class="container" v-loading="submitLoading">
            <!--<div class="ReceivingTips">
                您已选择直邮，根据中国海关规定，所有直邮包裹必须提供身份证号码及照片信息如实申报。请在下单后立即上传身份证，一面影响您的包裹收件。
            </div>-->
            <div class="shoppingCartBtns">
                <button class="addCar" @click="$router.push({path:'/'})">再逛逛</button>
                <button class="buy" @click="pay">立即支付</button>
            </div>
        </div>
        <el-dialog title="收件人" top="5vh" :visible.sync="receiptorDialogVisible"
                   :close-on-click-modal="false" @closed="receiptorDialogVisible=false">
            <cpnpeceiptor :isChoiseReceiptor="receiptorDialogVisible"
                          v-on:choisedReceiptor="choiseReceiptor"></cpnpeceiptor>
        </el-dialog>
        <el-dialog title="我的优惠券" top="5vh" :visible.sync="isShowCoupons" width="600px"
            :close-on-click-modal="false" @closed="isShowCoupons=false">
            <mycoupons :randomVal="Math.random()" v-on:immediateUse="immediateUse"></mycoupons>
            <div slot="footer">
                <el-button class="cancelBtn" @click="cancelCoupons">取消使用优惠券</el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import shopCart from '@/js/mixins/shopCart.js'
    import cpnpeceiptor from '@/views/frontend/components/receiptor.vue'
    import mycoupons from '@/views/frontend/components/myCoupons.vue'
    export default {
        name: 'shoppingCart',
        components: {
            cpnpeceiptor,
            mycoupons
        },
        mixins: [shopCart],
        data () {
            return {
                submitLoading:false,
                isDirectOrder: false, //是否直接下单，直接下单不管购物车里面的产品
                freight: 0, //运费
                recipient: 0, // 暂时无用
                shops: [], // 门店列表
                items: [], // 购物车的结构 [{id: id, num: num }]
                selections: [], //被选中的产品，如果是点击直接购买进来的，默认就选中
                selectedAll: false,
                receiptorDialogVisible: false,
                createOrderModel: {
                    'orderType': 1, //线上订单
                    "memberId": 0,
                    'tenantId': null, // 自提门店
                    'cashAmount': 0, // 积分抵扣金额
                    'couponId': null, // 使用的优惠券ID
                    'needTakePhoto': false, // 是否需要签字服务
                    'remark': '',
                    "consignor": {
                        "name": "",
                        "tel": ""
                    },
                    'addressee': null, /* { // 收件人
                        "name": '',
                        "tel": '',
                        "province": '',
                        "city": '',
                        "area": '',
                        "detail": '',
                        "idCardNo": '',
                        "idCardFrontImageUrl": '',
                        "idCardBackImageUrl": ""
                    },*/
                    'items': [
                        /*{
                            "commodityId": 0,
                            "quantity": 0
                        }*/
                    ]
                },
                isShowCoupons: false,
                cashAmount: "",  //输入的现金券
                couponsItem: {}, //选中的优惠券
                myInfos: {},
                orderWeight: 0.00,  // 重量
                commodityAmount: 0.00, // 商品合计
                paymentAmount: 0.00, // 应付金额
                paymentAmountRMB: 0.00, // 应付人民币
                needTakePhoto: false, // 是否选择拍照服务
                orderAmountJson: {}, // 计算订单价格返回的json数据
                appConfig: {}, // 获取配置信息
                priceType: 0
            }
        },
        computed: {
            totalData () {
                let _totalData = {
                    price: 0,
                    weight: 0,
                }
                if (this.selections.length > 0) {
                    let arr = this.selections.map(x => {
                        return x.commodity.price * x.quantity
                    }) //产品的小计集合
                    var total = arr.reduce(function (num, item, index) {
                        return num + item
                    })
                    //计算优惠券和现金券
                    let cash = this.cashAmount || 0;
                    let coupons = this.couponsItem.amount || 0;
                    total = total + parseFloat(this.freight) - cash - coupons;
                    total = total <= 0 ? 0 : total;

                    _totalData.price = this.toFixed(total)
                    //重量计算
                    let arrWeight = this.selections.map(x => {
                        return x.commodity.weight * x.quantity
                    }) //产品的小计集合
                    var totalWeight = arrWeight.reduce(function (num, item, index) {
                        return num + item
                    })
                    _totalData.weight = this.toFixed(totalWeight)
                }
                return _totalData
            }
        },
        watch: {
            /*selectedAll (v) {
                if (v) {
                    this.selections = this.items
                } else {
                    this.selections = []
                }
            }*/
            selections: {
                deep: true,
                handler: function (newVal, oldVal) {
                    //console.log('filter change')
                    this.ComputeFreight()
                }
            },
            /*cashAmount(v) {
                console.log(v)
                if (!this.cashAmount || this.cashAmount <= 0) {
                    this.cashAmount = "";
                } else if (this.cashAmount >= this.myInfos.cash) {
                    this.cashAmount = this.myInfos.cash;
                }
            },*/
            '$route'(){
                location.reload();
            }
        },
        mounted () {
            this.getAppSetting()
            this.getMyInfo();
            this.getShopCartLit();
            this.getShops()
        },
        methods: {
            getAppSetting() {
                this.axios.get(window.consts.apis.getAppSetting).then(res=>{
                    if(res.success && res.result){
                        this.appConfig = res.result
                    }
                })
            },
            useCashAmount(){
                if(this.cashAmount)
                {
                    if(window.consts.validate.reg_decimal.test(this.cashAmount) === false){
                        this.cashAmount="";
                        this.$message.error('请输入有效金额');
                    }
                    if (Number(this.cashAmount) > this.myInfos.cash) {
                        this.cashAmount = this.myInfos.cash;
                    }
                }
                this.ComputeFreight(true)
            },
            ComputeFreight (isUnLoading) {
                this.orderAmountJson = {}
                this.freight = 0
                this.orderWeight = 0.00
                this.commodityAmount = 0.00
                this.paymentAmount = 0.00
                this.paymentAmountRMB = 0.00
                if (this.selections.length === 0) {
                    this.orderAmountJson = {}
                    this.freight = 0
                    this.orderWeight = 0.00
                    this.commodityAmount = 0.00
                    this.paymentAmount = 0.00
                    this.paymentAmountRMB = 0.00
                } else {
                    let items = this.selections.map(x => {
                        return {
                            'commodityId': x.commodityId,
                            'quantity': x.quantity
                        }
                    })
                    if (!isUnLoading) {
                        this.showPcLoading();
                    }
                    let isSelfGet = this.createOrderModel && this.createOrderModel.tenantId && this.createOrderModel.tenantId > 0
                    this.$axios.post(window.consts.apis.computeAmount, {
                        "commodities": items,
                        "cashAmount": this.cashAmount || 0,
                        "couponId": this.couponsItem.id || null,
                        "isSelfGet": isSelfGet || false,
                        "needTakePhoto": this.needTakePhoto || false
                    }).then(r => {
                        this.hidePcLoading();
                        if (r.success) {
                            this.orderAmountJson = r.result // 计算的订单价格返回结果
                            this.freight = r.result.freight // 运费
                            this.orderWeight = r.result.weight  // 重量
                            this.commodityAmount = r.result.commodityAmount  // 商品合计
                            this.paymentAmount = r.result.paymentAmount  // 应付金额
                            this.paymentAmountRMB = this.toFixed(r.result.paymentAmount * (this.appConfig && this.appConfig.exchangeRate)) // 人民币
                        } else {
                            this.$alert(r.error.message, '')
                        }
                    }).catch(e => {
                        this.hidePcLoading();
                    })
                }
            },
            getMyInfo() {
                this.$axios.get(window.consts.apis.getMyInfo).then(res => {
                    if (res.success) {
                        this.myInfos = res.result;
                        this.createOrderModel.consignor.name = res.result.consignor.name;
                        this.createOrderModel.consignor.tel = res.result.consignor.tel;
                    }
                }).catch(e => {

                });
            },
            getShopCartLit() {
                let that = this;
                this.setWindowTitle('购物车')
                //优先处理直接购买--------------------地址栏传参的情况
                let q = this.$route.query
                if (q && q.id) {
                    this.setWindowTitle('直接下单')
                    this.isDirectOrder = true
                    let _num = q.num > 0 ? q.num : 1
                    this.axios.get(window.consts.apis.product + '?id=' + q.id).then(res => {
                        if (res.success) {
                            this.product = res.result
                            this.items = [
                                {
                                    commodity: res.result,
                                    commodityId: q.id,
                                    quantity: _num,
                                }
                            ]
                            this.selectedAll = true
                            this.selections = JSON.parse(JSON.stringify(this.items)) // 点击直接购买进来的，默认就选中
                            // 改变当前币种状态
                            this.priceType = res.result.priceType
                        } else {
                            this.$alert(res.error.message, '')
                        }
                    }).catch(res => {
                        // loading.close()
                    })
                }
                //非直接购买再读取购物车数据
                else {
                    this.isDirectOrder = false
                    this.showPcLoading();
                    this.$axios.get(window.consts.apis.getShoppingCartList).then(res => {
                        this.hidePcLoading();
                        if (res.success) {
                            //this.items = res.result.items
                            this.syncShopCart(res.result.items, function() {
                                that.getShopCartListReload();
                            });
                        }
                    }).catch(e => {
                        this.hidePcLoading();
                    })
                }
            },
            getShopCartListReload() {
                this.$axios.get(window.consts.apis.getShoppingCartList, { params: { Page: 1, Size: 100} }).then(res => {
                    if (res.success) {
                        this.items = res.result.items.filter(x => {
                            return x.commodity.priceType === this.priceType
                        })
                    }
                })
            },
            selectAllHandle () {
                if (this.isDirectOrder) {
                    this.$message({
                        message: '直接购买的商品不能取消选择',
                        type: 'warning'
                    })
                    return false
                } else {
                    this.selectedAll = !this.selectedAll
                    if (this.selectedAll) {
                        this.selections = JSON.parse(JSON.stringify(this.items))
                    } else {
                        this.selections = []
                    }
                }
            },
            changeSelectState (item) {
                if (this.isDirectOrder) {
                    this.$message({
                        message: '直接购买的商品不能取消选择',
                        type: 'warning'
                    })
                    return false
                } else {
                    //console.log(this.selections.map(x=>x.commodityId).join(','))
                    if (this.selections.filter(x => x.commodityId === item.commodityId).length === 0) {
                        this.selections.push(item)
                    } else {
                        //移除
                        let index = this.selections.findIndex((element) => (element.commodityId === item.commodityId))
                        this.selections.splice(index, 1)
                        //console.log('index',index)
                    }
                    //console.log('===========',this.selections.map(x=>x.commodityId).join(','))
                }
                // 实现选中全选
                if (this.selections.length <= 0) {
                    this.selectedAll = false
                } else if (this.selections.length === this.items.length) {
                    this.selectedAll = true
                }
            },
            //修改购物车数量
            changeNumber (item, isDelete) {
                if (this.isDirectOrder === false) {
                    if (isDelete) {
                        this.$confirm('确定要删除购物车数据吗？', '', {
                            confirmButtonText: '确定',
                            cancelButtonText: '取消',
                            type: 'warning'
                        }).then(r => {
                            this._editCart({ commodityId: item.commodityId, quantity: item.quantity }).then(res => {
                                if (res.success) {
                                    if (this.deleteShopCartLocalStorage(item)) {
                                        this.getShopCartListReload();
                                    }
                                } else {
                                    this.$alert(res.error.message, '')
                                }
                            }).catch(e => {
                                this.$alert(e, '')
                            })
                            for (let i = 0; i < this.selections.length; i++) {
                                if (this.selections[i].commodityId === item.commodityId) {
                                    this.selections[i].quantity = item.quantity
                                }
                            }
                        })
                    } else {
                        this._editCart({ commodityId: item.commodityId, quantity: item.quantity }).then(res => {
                            if (res.success) {
                                this.setShopCartLocalStorage(item, 1);
                            } else {
                                this.$alert(res.error.message, '')
                            }
                        }).catch(e => {
                            this.$alert(e, '')
                        })
                        for (let i = 0; i < this.selections.length; i++) {
                            if (this.selections[i].commodityId === item.commodityId) {
                                this.selections[i].quantity = item.quantity
                            }
                        }
                    }
                } else {
                    for (let i = 0; i < this.selections.length; i++) {
                        if (this.selections[i].commodityId === item.commodityId) {
                            this.selections[i].quantity = item.quantity
                        }
                    }
                }
                /*if (this.isDirectOrder === false) {
                    this._editCart({ commodityId: item.commodityId, quantity: item.quantity }).then(res => {
                        if (res.success) {
                            if (isDelete) {
                                this.$confirm('确定要删除购物车数据吗？', '', {
                                    confirmButtonText: '确定',
                                    cancelButtonText: '取消',
                                    type: 'warning'
                                }).then(() => {
                                    if (this.deleteShopCartLocalStorage(item)) {
                                        this.getShopCartListReload();
                                    }
                                }).catch(() => { });
                            } else {
                                this.setShopCartLocalStorage(item, 1);
                                //this.addToCartTipsVisible = true
                            }
                        } else {
                            this.$alert(res.error.message, '')
                        }
                    }).catch(e => {
                        this.$alert(e, '')
                    })
                    for (let i = 0; i < this.selections.length; i++) {
                        if (this.selections[i].commodityId === item.commodityId) {
                            this.selections[i].quantity = item.quantity
                        }
                    }
                    // todo 修改选中项的数量
                } else {
                    for (let i = 0; i < this.selections.length; i++) {
                        if (this.selections[i].commodityId === item.commodityId) {
                            this.selections[i].quantity = item.quantity
                        }
                    }
                }*/
            },
            deleteItem(item) {
                if (!item || !item.commodity || isNaN(item.commodity.id) || item.commodity.id <= 0) {
                    return false;
                }
                let temp = {
                    commodityId: item.commodity.id,
                    quantity: 0
                };
                this.changeNumber(temp, true);
            },
            clearCart() {
                this.$confirm('确定要清空购物车吗？', '', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    this.$axios.post(window.consts.apis.clearShopCart).then(res => {
                        if (res.success) {
                            this.commodityAmount = 0.00
                            this.paymentAmount = 0.00
                            this.paymentAmountRMB = 0.00
                            this.clearShopCartLocalStorage(() => {
                                location.reload()
                            });
                            this.getShopCartListReload();
                        }
                    })
                }).catch(() => { });
            },
            // 获取门店列表
            getShops () {
                this.$axios.get(window.consts.apis.shopList + '?page=1&size=1000').then(res => {
                    if (res.success) {
                        this.shops = res.result.items
                    }
                }).catch(e => {

                })
            },
            pay () {
                let that = this;
                if (this.selections.length === 0) {
                    this.$message({
                        message: '请选择要购买的商品',
                        type: 'warning'
                    })
                    return false
                }
                if (this.createOrderModel.addressee === null && (!this.createOrderModel.tenantId || this.createOrderModel.tenantId <= 0)) {
                    this.$message({
                        message: '请选择收件人',
                        type: 'warning'
                    })
                    return false
                }
                if (!this.createOrderModel.consignor || !this.createOrderModel.consignor.name || !this.createOrderModel.consignor.tel) {
                    this.$message({
                        message: '请填写寄件人信息',
                        type: 'warning'
                    })
                    return false
                }
                this.createOrderModel.items = this.selections.map(x => {
                    return {
                        'commodityId': x.commodityId,
                        'quantity': x.quantity
                    }
                })
                //创建订单
                this.createOrderModel.memberId = this.myInfos.id;
                this.createOrderModel.cashAmount = this.cashAmount || 0;
                this.createOrderModel.couponId = this.couponsItem.id || null;
                this.createOrderModel.needTakePhoto = this.needTakePhoto
                this.submitLoading=true;
                this.$axios.post(window.consts.apis.createOrder, this.createOrderModel).then(r => {
                    this.submitLoading=false;
                    if (r.success) {
                        this.$message({
                            message: '订单提交成功!',
                            type: 'success',
                            onClose: (rt => {
                                if (this.isDirectOrder) {
                                    this.$router.push({ path: '/pay', query: { orderId: r.result.id } })
                                } else {
                                    this.deleteShopCartLocalStorageArray(this.createOrderModel.items, function(){
                                        that.$router.push({ path: '/pay', query: { orderId: r.result.id } })
                                    });
                                }
                            })
                        });
                    } else {
                        this.$alert(r.error.message, '')
                    }
                }).catch(e => {
                    this.submitLoading=false;
                    this.$alert('未知错误', '')
                })
            },
            //选择收件人
            choiseReceiptor (item) {
                this.receiptorDialogVisible = false
                this.createOrderModel.addressee = item.addressee
            },
            // 选择提货方式
            choiseReceivingWay (store) {
                if (store) {
                    this.createOrderModel.tenantId = store.id
                } else {
                    this.createOrderModel.tenantId = null
                }
                this.ComputeFreight()
            },
            // 选择拍照服务
            choiseServiceFee() {
                this.needTakePhoto = !this.needTakePhoto
                if (this.needTakePhoto) {
                    this.$prompt('', '给卖家留言').then(({ value }) => {
                        this.createOrderModel.remark = value
                    })
                }
                this.ComputeFreight()
            },
            cancelCoupons() {
                this.couponsItem = {};
                this.isShowCoupons = false;
                this.ComputeFreight(true);
            },
            immediateUse(data) {
                this.couponsItem = data;
                this.ComputeFreight()
                this.isShowCoupons = false;
            },
            changePriceType(type) {
                // 设置币种
                this.priceType = type
                // 更新购物车显示数据
                this.getShopCartListReload()
                // 取消全选，因此默认设为已经全选
                this.selectedAll = true
                this.selectAllHandle()
                // 重置优惠券
                this.cashAmount = null
                this.useCashAmount()
                // 重置拍照服务费
                this.needTakePhoto = true
                this.choiseServiceFee()
            }
        }
    }
</script>


